/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления реле устройства
 */

/**
 * Сервис управления реле устройства
 */
export class RelayServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод закрытия реле.
   * Закрытие реле принудительно без учета времени открытия.
   * Отмена режима постоянного открытия
   */
  PostRelayClose = (req: PostRelayCloseRequestDto, init?: RequestInit): Promise<PostRelayCloseResponseDto> => {
    return fm.request<PostRelayCloseRequestDto, PostRelayCloseResponseDto>(`${this.host}/device/api/v1/relay/${encodeURIComponent(req.relayIndex)}/close`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод открытия реле
   */
  PostRelayOpen = (req: PostRelayOpenRequestDto, init?: RequestInit): Promise<PostRelayOpenResponseDto> => {
    return fm.request<PostRelayOpenRequestDto, PostRelayOpenResponseDto>(`${this.host}/device/api/v1/relay/${encodeURIComponent(req.relayIndex)}/open`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод открытия реле без дальнейшего закрытия
   */
  PostRelayOpenPermanently = (req: PostRelayOpenPermanentlyRequestDto, init?: RequestInit): Promise<PostRelayOpenPermanentlyResponseDto> => {
    return fm.request<PostRelayOpenPermanentlyRequestDto, PostRelayOpenPermanentlyResponseDto>(`${this.host}/device/api/v1/relay/${encodeURIComponent(req.relayIndex)}/open_permanently`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования настроек открытия реле
   */
  EditRelayPropsOpen = (req: Pick<EditRelayPropsOpenRequestDto, "updateMask"> & { data: Pick<RelayOpenRequestDto, "relayIndex"> & fm.RequireAtLeastOne<Omit<RelayOpenRequestDto, "relayIndex">> }, init?: RequestInit): Promise<EditRelayPropsOpenResponseDto> => {
    return fm.request<Pick<EditRelayPropsOpenRequestDto, "updateMask"> & { data: Pick<RelayOpenRequestDto, "relayIndex"> & fm.RequireAtLeastOne<Omit<RelayOpenRequestDto, "relayIndex">> }, EditRelayPropsOpenResponseDto>(`${this.host}/device/api/v1/relay/${encodeURIComponent(req.data.relayIndex)}/props/open`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек открытия реле
   */
  GetRelayOpenList = (req?: GetRelayOpenListRequestDto, init?: RequestInit): Promise<GetRelayOpenListResponseDto> => {
    return fm.request<GetRelayOpenListRequestDto, GetRelayOpenListResponseDto>(`${this.host}/device/api/v1/relay/open/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования настроек DTMF реле
   */
  EditRelayPropsDtmf = (req: Pick<EditRelayPropsDtmfRequestDto, "updateMask"> & { data: Pick<RelayDtmfRequestDto, "relayIndex"> & fm.RequireAtLeastOne<Omit<RelayDtmfRequestDto, "relayIndex">> }, init?: RequestInit): Promise<EditRelayPropsDtmfResponseDto> => {
    return fm.request<Pick<EditRelayPropsDtmfRequestDto, "updateMask"> & { data: Pick<RelayDtmfRequestDto, "relayIndex"> & fm.RequireAtLeastOne<Omit<RelayDtmfRequestDto, "relayIndex">> }, EditRelayPropsDtmfResponseDto>(`${this.host}/device/api/v1/relay/${encodeURIComponent(req.data.relayIndex)}/props/dtmf`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек DTMF реле
   */
  GetRelayDtmfList = (req?: GetRelayDtmfListRequestDto, init?: RequestInit): Promise<GetRelayDtmfListResponseDto> => {
    return fm.request<GetRelayDtmfListRequestDto, GetRelayDtmfListResponseDto>(`${this.host}/device/api/v1/relay/dtmf/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения статусов реле устройства
   */
  GetRelayStatusList = (req?: GetRelayStatusListRequestDto, init?: RequestInit): Promise<GetRelayStatusListResponseDto> => {
    return fm.request<GetRelayStatusListRequestDto, GetRelayStatusListResponseDto>(`${this.host}/device/api/v1/relay/status/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип замка
 */
export enum RelayOpenLockType {
  /**
   * Значение не указано
   */
  LOCK_TYPE_UNKNOWN = "LOCK_TYPE_UNKNOWN",
  /**
   * Электромагнитный (state_operation)
   */
  ELECTROMAGNETIC = "ELECTROMAGNETIC",
  /**
   * Электромеханический (pulse_operation)
   */
  ELECTROMECHANICAL = "ELECTROMECHANICAL",
}
/**
 * Тип замка
 */
export type RelayOpenLockTypeResponseEnum = keyof typeof RelayOpenLockType
/**
 * Тип замка
 */
export type RelayOpenLockTypeRequestEnum = Exclude<RelayOpenLockTypeResponseEnum, "LOCK_TYPE_UNKNOWN">;

/**
 * Тип состояния
 */
export enum RelayStateStateType {
  /**
   * Значение не указано
   */
  STATE_TYPE_UNKNOWN = "STATE_TYPE_UNKNOWN",
  /**
   * Открыто временно
   */
  OPEN_TEMPORARY = "OPEN_TEMPORARY",
  /**
   * Закрыто
   */
  CLOSED = "CLOSED",
  /**
   * Открыто на всегда
   */
  OPEN_PERMANENT = "OPEN_PERMANENT",
}
/**
 * Тип состояния
 */
export type RelayStateStateTypeResponseEnum = keyof typeof RelayStateStateType
/**
 * Тип состояния
 */
export type RelayStateStateTypeRequestEnum = Exclude<RelayStateStateTypeResponseEnum, "STATE_TYPE_UNKNOWN">;

/**
 * Запрос на установку настроек DTMF реле
 */
export type EditRelayPropsDtmfRequestDto = {
  /**
   * Настройки DTMF реле
   */
  data: RelayDtmfRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос на установку настроек DTMF
 */
export type EditRelayPropsDtmfResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditRelayPropsDtmfResponseErrorDto
}>
/**
 * Ошибка запроса на установку настроек DTMF
 */
export type EditRelayPropsDtmfResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на установку настроек DTMF
 */
export type EditRelayPropsDtmfResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос редактирования настроек открытия реле
 */
export type EditRelayPropsOpenRequestDto = {
  /**
   * Настройки реле
   */
  data: RelayOpenRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос на установку настроек открытия реле
 */
export type EditRelayPropsOpenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditRelayPropsOpenResponseErrorDto
}>
/**
 * Ошибка запроса на установку настроек открытия реле
 */
export type EditRelayPropsOpenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на установку настроек открытия реле
 */
export type EditRelayPropsOpenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек DTMF реле
 */
export type GetRelayDtmfListRequestDto = {
}
/**
 * Ответ на запрос получения настроек DTMF реле
 */
export type GetRelayDtmfListResponseDto = {
  /**
   * Настройки DTMF реле
   */
  data: RelayDtmfResponseDto[]
}
/**
 * Запрос получения настроек открытия реле
 */
export type GetRelayOpenListRequestDto = {
}
/**
 * Ответ на запрос получения настроек открытия реле
 */
export type GetRelayOpenListResponseDto = {
  /**
   * Настройки открытия реле
   */
  data: RelayOpenResponseDto[]
}
/**
 * Запрос получения статусов реле устройства
 */
export type GetRelayStatusListRequestDto = {
}
/**
 * Ответ на запрос получения статусов реле устройства
 */
export type GetRelayStatusListResponseDto = {
  /**
   * Список состояний реле
   */
  data: RelayStateResponseDto[]
}
/**
 * Запрос закрытия реле
 */
export type PostRelayCloseRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
}
/**
 * Ответ на запрос закрытия реле
 */
export type PostRelayCloseResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostRelayCloseResponseErrorDto
}>
/**
 * Ошибка запроса закрытия реле
 */
export type PostRelayCloseResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса закрытия реле
 */
export type PostRelayCloseResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос открытия реле без дальнейшего закрытия
 */
export type PostRelayOpenPermanentlyRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
}
/**
 * Ответ на запрос открытия реле без дальнейшего закрытия
 */
export type PostRelayOpenPermanentlyResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostRelayOpenPermanentlyResponseErrorDto
}>
/**
 * Ошибка запроса открытия реле без дальнейшего закрытия
 */
export type PostRelayOpenPermanentlyResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса открытия реле без дальнейшего закрытия
 */
export type PostRelayOpenPermanentlyResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос открытия реле
 */
export type PostRelayOpenRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Задержка в секундах.
   * Если не передано, используется установленное значение времени открытия из настроек.
   * Диапазон: 1..200
   */
  currentOpenTime?: number
}
/**
 * Ответ на запрос открытия реле
 */
export type PostRelayOpenResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostRelayOpenResponseErrorDto
}>
/**
 * Ошибка запроса открытия реле
 */
export type PostRelayOpenResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса открытия реле
 */
export type PostRelayOpenResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Настройки DTMF реле
 */
export type RelayDtmfRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * DTMF код.
   * Для разных реле допускается одинаковый DTMF код.
   * Один символ из 0,1,2,3,4,5,6,7,8,9,*,#
   */
  dtmfCode?: string
}
/**
 * Настройки DTMF реле
 */
export type RelayDtmfResponseDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * DTMF код.
   * Для разных реле допускается одинаковый DTMF код.
   * Один символ из 0,1,2,3,4,5,6,7,8,9,*,#
   */
  dtmfCode: string
}
/**
 * Настройки открытия реле
 */
export type RelayOpenRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Тип замка
   */
  lockType?: RelayOpenLockTypeRequestEnum | "LOCK_TYPE_UNKNOWN"
  /**
   * Общее время открытия.
   * Диапазон: 1..200
   */
  openTimeGeneral?: number
  /**
   * Время открытия в секундах при экстренном оповещении.
   * При 0 - до конца экстренного оповещения.
   * Диапазон: 0..3600
   */
  openTimeEmergency?: number
}
/**
 * Настройки открытия реле
 */
export type RelayOpenResponseDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Тип замка
   */
  lockType: RelayOpenLockTypeResponseEnum
  /**
   * Общее время открытия.
   * Диапазон: 1..200
   */
  openTimeGeneral: number
  /**
   * Время открытия в секундах при экстренном оповещении.
   * При 0 - до конца экстренного оповещения.
   * Диапазон: 0..3600
   */
  openTimeEmergency: number
}
/**
 * Состояние реле
 */
export type RelayStateRequestDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Состояние
   */
  stateType?: RelayStateStateTypeRequestEnum | "STATE_TYPE_UNKNOWN"
}
/**
 * Состояние реле
 */
export type RelayStateResponseDto = {
  /**
   * Индекс реле.
   * Диапазон: 1..32767
   */
  relayIndex: number
  /**
   * Состояние
   */
  stateType: RelayStateStateTypeResponseEnum
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на установку настроек DTMF реле
   */
  "EditRelayPropsDtmfRequest": {
    "kind": "class",
    "text": "Запрос на установку настроек DTMF реле",
    "fields": {
      /**
       * Настройки DTMF реле
       */
      "data": {
        "type": "RelayDtmf",
        "text": "Настройки DTMF реле",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос на установку настроек DTMF
   */
  "EditRelayPropsDtmfResponse": {
    "kind": "class",
    "text": "Ответ на запрос на установку настроек DTMF",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditRelayPropsDtmfResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на установку настроек DTMF
   */
  "EditRelayPropsDtmfResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на установку настроек DTMF",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос редактирования настроек открытия реле
   */
  "EditRelayPropsOpenRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек открытия реле",
    "fields": {
      /**
       * Настройки реле
       */
      "data": {
        "type": "RelayOpen",
        "text": "Настройки реле",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос на установку настроек открытия реле
   */
  "EditRelayPropsOpenResponse": {
    "kind": "class",
    "text": "Ответ на запрос на установку настроек открытия реле",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditRelayPropsOpenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на установку настроек открытия реле
   */
  "EditRelayPropsOpenResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на установку настроек открытия реле",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек DTMF реле
   */
  "GetRelayDtmfListRequest": {
    "kind": "class",
    "text": "Запрос получения настроек DTMF реле",
  },
  /**
   * Ответ на запрос получения настроек DTMF реле
   */
  "GetRelayDtmfListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек DTMF реле",
    "fields": {
      /**
       * Настройки DTMF реле
       */
      "data": {
        "type": "RelayDtmf",
        "text": "Настройки DTMF реле",
      },
    },
  },
  /**
   * Запрос получения настроек открытия реле
   */
  "GetRelayOpenListRequest": {
    "kind": "class",
    "text": "Запрос получения настроек открытия реле",
  },
  /**
   * Ответ на запрос получения настроек открытия реле
   */
  "GetRelayOpenListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек открытия реле",
    "fields": {
      /**
       * Настройки открытия реле
       */
      "data": {
        "type": "RelayOpen",
        "text": "Настройки открытия реле",
      },
    },
  },
  /**
   * Запрос получения статусов реле устройства
   */
  "GetRelayStatusListRequest": {
    "kind": "class",
    "text": "Запрос получения статусов реле устройства",
  },
  /**
   * Ответ на запрос получения статусов реле устройства
   */
  "GetRelayStatusListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения статусов реле устройства",
    "fields": {
      /**
       * Список состояний реле
       */
      "data": {
        "type": "RelayState",
        "text": "Список состояний реле",
      },
    },
  },
  /**
   * Запрос закрытия реле
   */
  "PostRelayCloseRequest": {
    "kind": "class",
    "text": "Запрос закрытия реле",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос закрытия реле
   */
  "PostRelayCloseResponse": {
    "kind": "class",
    "text": "Ответ на запрос закрытия реле",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostRelayCloseResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса закрытия реле
   */
  "PostRelayCloseResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса закрытия реле",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос открытия реле без дальнейшего закрытия
   */
  "PostRelayOpenPermanentlyRequest": {
    "kind": "class",
    "text": "Запрос открытия реле без дальнейшего закрытия",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос открытия реле без дальнейшего закрытия
   */
  "PostRelayOpenPermanentlyResponse": {
    "kind": "class",
    "text": "Ответ на запрос открытия реле без дальнейшего закрытия",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostRelayOpenPermanentlyResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса открытия реле без дальнейшего закрытия
   */
  "PostRelayOpenPermanentlyResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса открытия реле без дальнейшего закрытия",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос открытия реле
   */
  "PostRelayOpenRequest": {
    "kind": "class",
    "text": "Запрос открытия реле",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Задержка в секундах.
       * Если не передано, используется установленное значение времени открытия из настроек.
       * Диапазон: 1..200
       */
      "currentOpenTime": {
        "type": "int32",
        "text": "Задержка в секундах.\nЕсли не передано, используется установленное значение времени открытия из настроек.\nДиапазон: 1..200",
      },
    },
  },
  /**
   * Ответ на запрос открытия реле
   */
  "PostRelayOpenResponse": {
    "kind": "class",
    "text": "Ответ на запрос открытия реле",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostRelayOpenResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса открытия реле
   */
  "PostRelayOpenResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса открытия реле",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Настройки DTMF реле
   */
  "RelayDtmf": {
    "kind": "class",
    "text": "Настройки DTMF реле",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * DTMF код.
       * Для разных реле допускается одинаковый DTMF код.
       * Один символ из 0,1,2,3,4,5,6,7,8,9,*,#
       */
      "dtmfCode": {
        "type": "string",
        "text": "DTMF код.\nДля разных реле допускается одинаковый DTMF код.\nОдин символ из 0,1,2,3,4,5,6,7,8,9,*,#",
      },
    },
  },
  /**
   * Настройки открытия реле
   */
  "RelayOpen": {
    "kind": "class",
    "text": "Настройки открытия реле",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип замка
       */
      "lockType": {
        "type": "RelayOpen.LockType",
        "text": "Тип замка",
      },
      /**
       * Общее время открытия.
       * Диапазон: 1..200
       */
      "openTimeGeneral": {
        "type": "int32",
        "text": "Общее время открытия.\nДиапазон: 1..200",
      },
      /**
       * Время открытия в секундах при экстренном оповещении.
       * При 0 - до конца экстренного оповещения.
       * Диапазон: 0..3600
       */
      "openTimeEmergency": {
        "type": "int32",
        "text": "Время открытия в секундах при экстренном оповещении.\nПри 0 - до конца экстренного оповещения.\nДиапазон: 0..3600",
      },
    },
  },
  /**
   * Состояние реле
   */
  "RelayState": {
    "kind": "class",
    "text": "Состояние реле",
    "fields": {
      /**
       * Индекс реле.
       * Диапазон: 1..32767
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\nДиапазон: 1..32767",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Состояние
       */
      "stateType": {
        "type": "RelayState.StateType",
        "text": "Состояние",
      },
    },
  },
  /**
   * Тип замка
   */
  "RelayOpen.LockType": {
    "kind": "enum",
    "text": "Тип замка",
    "values": {
      /**
       * Значение не указано
       */
      "LOCK_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Электромагнитный (state_operation)
       */
      "ELECTROMAGNETIC": {
        "i": 1,
        "text": "Электромагнитный (state_operation)",
      },
      /**
       * Электромеханический (pulse_operation)
       */
      "ELECTROMECHANICAL": {
        "i": 2,
        "text": "Электромеханический (pulse_operation)",
      },
    },
  },
  /**
   * Тип состояния
   */
  "RelayState.StateType": {
    "kind": "enum",
    "text": "Тип состояния",
    "values": {
      /**
       * Значение не указано
       */
      "STATE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Открыто временно
       */
      "OPEN_TEMPORARY": {
        "i": 1,
        "text": "Открыто временно",
      },
      /**
       * Закрыто
       */
      "CLOSED": {
        "i": 2,
        "text": "Закрыто",
      },
      /**
       * Открыто на всегда
       */
      "OPEN_PERMANENT": {
        "i": 3,
        "text": "Открыто на всегда",
      },
    },
  },
}